module.exports = __webpack_public_path__ + "img/part5-13.f87fcf88.png";